import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Divider, Form, Input, Upload } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { debounce } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import {
  formValidatorRules,
  getBase64,
  validateImage,
} from '../../../../../common/utils';
import ModalComponent from '../../../../../components/ModalComponent';

const { Item } = Form;
const { required } = formValidatorRules;

const FacilitatesModal = ({
  isModalOpen,
  setIsModalOpen,
  onFinish,
  loadings,
  form,
  facilitates,
  setFacilitates,
  facilitatesImages,
  setFacilitatesImages,
  setVisible,
  setFacilitatesPreviewImage,
  colour,
  setColour,
}) => {
  const [isValidateTrigger, setIsValidateTrigger] = useState(false);
  const [inputColour, setInputColour] = useState(colour);

  const handleCancel = () => {
    setIsModalOpen(false);
    setFacilitates();
    form?.resetFields();
  };

  const debouncedSetColour = useCallback(
    debounce((val) => {
      setColour(val);
    }, 300),
    [],
  );

  useEffect(() => {
    debouncedSetColour(inputColour);
  }, [inputColour]);

  useEffect(() => {
    form?.setFieldsValue({
      name: facilitates?.name,
      description: facilitates?.description,
      colour: facilitates?.colour,
    });
    setColour(facilitates?.colour);
  }, [facilitates]);

  const handleImageChange = (info) => {
    validateImage(info, form, setFacilitatesImages, 'image');
  };

  const handlePreview = async (fileObj) => {
    let preview;
    if (!fileObj?.url && !fileObj?.preview) {
      preview = await getBase64(fileObj?.originFileObj);
    }
    setVisible(true);
    setFacilitatesPreviewImage(fileObj?.url || preview);
  };
  return (
    <>
      <ModalComponent
        open={isModalOpen}
        onCancel={handleCancel}
        onOk={form?.submit}
        title={facilitates ? 'Edit Facilitates' : 'Add New Facilitates'}
        okText="Save"
        confirmLoading={loadings}
        destroyOnClose
        forceRender
      >
        <Divider />
        <Form
          form={form}
          onFinish={(values) => {
            onFinish(values);
            setIsValidateTrigger(true);
          }}
          autoComplete="off"
          layout="vertical"
          validateTrigger={isValidateTrigger ? 'onChange' : 'onSubmit'}
          onFinishFailed={() => setIsValidateTrigger(true)}
        >
          <Item
            label="Name"
            name="name"
            rules={[{ ...required, message: 'Please Enter Name!' }]}
          >
            <Input allowClear placeholder="Enter Name" maxLength={50} />
          </Item>
          <Item label="Description" name="description">
            <TextArea allowClear placeholder="Enter Name" />
          </Item>
          <Item label="Color" name="colour">
            {colour ? (
              <>
                <Input
                  onChange={(e) => {
                    setInputColour(e.target.value);
                  }}
                  type="color"
                  allowClear
                  placeholder="Select Color"
                  className="facilitate-color"
                  value={colour}
                />
                <Button
                  icon={<CloseOutlined />}
                  onClick={() => {
                    setColour('');
                  }}
                  size="small"
                  className="close-btn"
                />
              </>
            ) : (
              <Button onClick={() => setColour('#ea1f1f')}>Select Color</Button>
            )}
          </Item>

          <Item label="Image" name="image">
            <Upload
              listType="picture-card"
              maxCount={1}
              fileList={facilitatesImages}
              beforeUpload={() => false}
              onPreview={handlePreview}
              onChange={handleImageChange}
              showUploadList={{
                showDownloadIcon: false,
                showPreviewIcon: true,
                showRemoveIcon: true,
              }}
            >
              {facilitatesImages?.length !== 1 && <PlusOutlined />}
            </Upload>
          </Item>
        </Form>
      </ModalComponent>
    </>
  );
};

export default FacilitatesModal;
